module.exports = __webpack_public_path__ + "img/sidepanel_arr.bfede2d8.webp";